//スクロール、マウスホイールイベントの停止
var PreventScroll = function(){
    this.$window = $(window);
    this.delta = 0;
};
PreventScroll.prototype = {
    on: function(exclusion) {
        this.$window.on('scroll DOMMouseScroll mousewheel touchmove', this._preventHandler);
    },
    off: function() {
        this.$window.off('scroll DOMMouseScroll mousewheel touchmove', this._preventHandler);
    },
    wheelOn: function(exclusion) {
        this.$window.on('mousewheel', this._preventHandler);
    },
    wheelOff: function() {
        this.$window.off('mousewheel', this._preventHandler);
    },
    _preventHandler: function(e) {
        //console.log(e);
        e.preventDefault();
        this.delta = e.originalEvent.deltaY ? -(e.originalEvent.deltaY) : e.originalEvent.wheelDelta ? e.originalEvent.wheelDelta : -(e.originalEvent.detail);
    }
};

module.exports = PreventScroll;


/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/pc/assets/js/module/PreventScroll.js
 **/